<app-forms-list
    [areFormsLoading]="areFormsLoading"
    [forms]="forms"
    (formSelected)="selectForm($event)"></app-forms-list>
